const SONAR_TABLE_HEADER = [
  {
    key: 'interest',
    title: 'interest',
  },
  {
    key: 'trust',
    title: 'trust',
  },
  {
    key: 'passion',
    title: 'passion',
  },
  {
    key: 'relevanceStrength',
    title: 'relevanceStrength',
  },
  {
    key: 'relevanceBreadth',
    title: 'relevanceBreadth',
  },
  {
    key: 'friction',
    title: 'rivalry',
  },
  {
    key: 'presence',
    title: 'reach',
  },
  {
    key: 'energy',
    title: 'vitality',
  },
  {
    key: 'powerrank',
    title: 'powerrank',
  },
];

export default SONAR_TABLE_HEADER;
